import { BaseEvents } from '@/shared/utils';
import { DeleteProfileSkillLevelSchema, ProfileSkillLevelSchema } from './types';

export const InstrumentsEventKeys = {
  instruments: {
    options: 'instruments/options/get',
    profile: 'instruments/profile/get',
    skillLevels: {
      get: 'instruments/skill-levels/get',
      create: 'instruments/skill-levels/create',
      update: 'instruments/skill-levels/update',
      delete: 'instruments/skill-levels/delete',
    },
  },
} as const;

export interface InstrumentsEvents extends BaseEvents {
  'instruments/options/get': void;
  'instruments/skill-levels/get': void;
  'instruments/skill-levels/create': {
    data: ProfileSkillLevelSchema;
    onSuccess: () => void;
  };
  'instruments/skill-levels/update': {
    data: ProfileSkillLevelSchema;
    onSuccess: () => void;
  };
  'instruments/profile/get': { email: string };
  'instruments/skill-levels/delete': {
    data: DeleteProfileSkillLevelSchema;
    onSuccess: () => void;
  };
}
